import { Link } from "react-router-dom";
import { Phone } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/7a572c44-1649-4021-b058-d6735529437c/images/d94df88ba12598bcf6ed003f1945686050a46963f58f2b2a0bcc9298fecdeb01.png";

export default function HeroSection() {
  return (
    <section 
      className="hero-section relative flex items-center justify-center"
      style={{ 
        backgroundImage: `url(${HERO_BG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      data-testid="hero-section"
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/30 via-transparent to-fuchsia-900/20" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 text-center py-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="font-['Outfit'] text-4xl sm:text-5xl lg:text-6xl font-bold text-white hero-text-shadow mb-6 tracking-tight">
            E@TECH La technologie au<br />
            <span className="text-white">service de la réussite scolaire !</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p className="text-lg sm:text-xl text-white/90 max-w-3xl mx-auto mb-4 hero-text-shadow">
            Avec E@tech, bénéficiez d'un partenaire dédié spécialisé dans le numérique 
            à destination des établissements scolaires.
          </p>
          <p className="text-base sm:text-lg text-white/80 max-w-2xl mx-auto mb-10 hero-text-shadow">
            Nous prenons en charge tous vos besoins pour que vous puissiez vous concentrer 
            sur l'essentiel : <strong className="text-white">La transmission du SAVOIR</strong>
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <Link to="/nous-contacter">
            <Button 
              size="lg"
              className="bg-slate-800/90 hover:bg-slate-900 text-white px-8 py-6 text-lg font-medium rounded-xl shadow-2xl btn-primary"
              data-testid="hero-cta-btn"
            >
              Parlons-en !
              <Phone size={24} weight="fill" className="ml-2" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
